import request from 'superagent';
import tree from '../state';
import config from '../config'

export function getCategory(category) {
    return request.get(`${config.apiBase}/api/category/${category}`)
        .set('authorization', tree.get('token'))
        .then(res => JSON.parse(res.text))
    ;
}


// WEBPACK FOOTER //
// ./src/services/categoryService.js